const Lock = () => (
  <svg viewBox='0 0 24 24'>
    <path d='M12 3.5a4.7 4.7 0 0 0-4.69 4.69V11h-.93c-1.04 0-1.88.84-1.88 1.88V20c0 1.04.84 1.5 1.88 1.5h11.24c1.04 0 1.88-.46 1.88-1.5v-7.13c0-1.03-.84-1.87-1.88-1.87h-.93V8.19A4.7 4.7 0 0 0 12 3.5ZM9.19 8.19a2.82 2.82 0 0 1 5.62 0V11H9.2V8.19Zm3.75 8.55v1.2a.94.94 0 1 1-1.88 0v-1.2a1.87 1.87 0 0 1 .53-3.45 1.88 1.88 0 0 1 1.35 3.45Z' />
  </svg>
)

export { Lock }
